import React, { useEffect } from 'react';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { appQueryClient } from './appQueryClient';
import { maxAgePersistStorage } from './queryConsts';
import { appQueryPersister, logPersistStats } from './setupAppQueryPersistence';

export function AppQueryProvider({ children }) {
    useEffect(() => {
        logPersistStats();
    }, []);
    return (
        <PersistQueryClientProvider
            client={appQueryClient}
            persistOptions={{
                persister: appQueryPersister,
                maxAge: maxAgePersistStorage,
                dehydrateOptions: {
                    /**
                     * Controls which React Query caches are written to sessionStorage.
                     * Default - persist = false, so explicitly set persist: true in React Query Hook.
                     * @param {*} query Whole query
                     * @returns Boolean to save to persist or not.
                     */
                    shouldDehydrateQuery: (query) => {
                        return query.meta?.persist !== false;
                    }
                }
            }}
            onSuccess={() => {
                console.log("Persist restored", { query: appQueryClient.getQueryCache().getAll() });
            }}
        >
            {children}
        </PersistQueryClientProvider>
    );
}
